import React, {useState} from "react";
import {Box, Button, Checkbox, FormControlLabel, Grid} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import AlunoTabEnrollEIL from "./AlunoTabEnrollEIL";
import {iEnrollment} from "../../types/iEnrollment";
import {useSelector} from "react-redux";
import {RootState} from "../../store/reducers";
import {iAluno} from "../../types/iAluno";
import AlunoEnrollmentDialog from "./AlunoEnrollmentDialog";
import {newEnrollment} from "../../types/Enrollment";
import { iEIL } from "../../types/iEIL";
import { AlunoEnrollContext } from "./alunoEnrollContext";


interface iAlunoTabEnroll {
    registro?: iAluno,
}
const AlunoTabEnroll = ( props : iAlunoTabEnroll) => {
    const { registro } = props;

    const [recId, setRecId] = useState<number | null>(null);
    const data = useSelector( (state : RootState) => state.cadastros.aluno );

    const [dataEnrollment, setDataEnrollment] = useState<iEnrollment>(newEnrollment);

    const [ isEnrollmentDialogOpen, setIsEnrollmentDialogOpen ] = useState(false);
    const [ showExcluded, setShowExcluded ] = useState(false);

    const dialogState = (param:boolean, recId?: number | null) => {
        const rId = recId ?? null;
        setRecId(rId);
        setIsEnrollmentDialogOpen(param);
    }

    const handleNovaMatricula = () => {
        setDataEnrollment(newEnrollment);
        dialogState(true);
    }

    return (<React.Fragment>

        <Grid>
            {isEnrollmentDialogOpen &&
                <AlunoEnrollmentDialog registro={dataEnrollment} aluno={data} isOpen={isEnrollmentDialogOpen} dialogState={dialogState}/>
            }

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 2, flexWrap: 'wrap' }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleNovaMatricula()}>Nova Matricula</Button>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showExcluded}
                            onChange={(e) => setShowExcluded(e.target.checked)}
                            size="small"
                        />
                    }
                    label="Listar disciplinas excluidas"
                />
            </Box>
        </Grid>

        <AlunoEnrollContext.Provider value={{ showExcluded }}>
            <Grid>
                { registro?.enrollmentInLevel?.map( (eil: iEIL, eilix: number) => {
                    return (
                        <React.Fragment key={eilix}>
                            <AlunoTabEnrollEIL key={eilix}  registro={eil} open={registro.enrollmentInLevel?.length === eilix+1 } />
                        </React.Fragment>
                    )
                })}
            </Grid>
        </AlunoEnrollContext.Provider>
    </React.Fragment>);
}
export default (AlunoTabEnroll);
